import api from "@modules/api/api";
import { QueryClient, useQuery } from "@tanstack/react-query";
import { FeatureFlags } from "../types/FeatureFlag";
import featureFlagsQueryKeys from "../featureFlagQueryKeys";

export const getFeatureFlagList = (): Promise<string[]> => {
  return api.get(`api/feature-flags/v2`);
};

export const prefetchFeatureFlagList = async (
  queryClient: QueryClient,
  // Used to force identification of which flag this is for. When a flag is removed we
  // need to know that we can stop doing this
  flags: FeatureFlags[]
) => {
  if (flags.length === 0)
    throw Error("Must list used feature flags for prefetching");

  await queryClient.prefetchQuery({
    queryKey: featureFlagsQueryKeys.featureFlagList(),
    queryFn: () => getFeatureFlagList(),
  });
};

export default function useFeatureFlags() {
  const { data, error, isLoading } = useQuery<string[], Error>({
    queryKey: featureFlagsQueryKeys.featureFlagList(),
    queryFn: () => getFeatureFlagList(),
    staleTime: 5 * 60 * 1000,
  });

  const isEnabled = (featureFlagName: FeatureFlags) => {
    return data?.some((f) => f === featureFlagName) ?? false;
  };

  return { data, isEnabled, error, isLoading };
}
